import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../../constants/TextConstants'
import SortButton from '../../SortButton'
import { HeaderCell, HeaderColumnDivider, HeaderDivider, HeaderWrapper } from './styles'
import { columnAndRowsWidth } from '..'

export const TableHeader = ({ sortState, toggleSort }) => {
  return (
    <>
      <HeaderWrapper>
        <HeaderCell
          $isSortIcon={true}
          $width={columnAndRowsWidth.roles}
          style={{ flexGrow: 1 }}
          data-testid='roles-header'>
          <span>{Text.RolesTitle}</span>
          <SortButton name='roles' sortOrder={sortState?.roles} toggleSort={toggleSort} />
        </HeaderCell>
        <HeaderColumnDivider />

        <HeaderCell $isSortIcon={true} $width={columnAndRowsWidth.users} data-testid='users-header'>
          <span>{Text.Users}</span>
          <SortButton name='users' sortOrder={sortState?.users} toggleSort={toggleSort} />
        </HeaderCell>
        <HeaderColumnDivider />

        <HeaderCell $isSortIcon={false} $width={columnAndRowsWidth.actions} data-testid='actions-header'>
          <span>{Text.Actions}</span>
        </HeaderCell>
        <HeaderColumnDivider />
      </HeaderWrapper>
      <HeaderDivider strokeColor='ui--secondary' strokeThickness={1} />
    </>
  )
}

TableHeader.propTypes = {
  sortState: PropTypes.shape({
    roles: PropTypes.shape({ order: PropTypes.oneOf(['asc', 'dsc']) }),
    users: PropTypes.shape({ order: PropTypes.oneOf(['asc', 'dsc']) })
  }).isRequired,
  toggleSort: PropTypes.func.isRequired
}
